import { Navigate, Route, Routes } from 'react-router';
import { PrepTreatment } from './PrepTreatment/PrepTreatment';

type PrepTreatmentRoutesProps = {
  /** Brand-specific embedded refill flow the restart path sends patients into. */
  refillFlowRoute: string;
};

// entry route: /treatments/*
export const PrepTreatmentRoutes = ({
  refillFlowRoute,
}: PrepTreatmentRoutesProps) => {
  return (
    <Routes>
      <Route path="/prep/*">
        <Route
          index
          element={<PrepTreatment refillFlowRoute={refillFlowRoute} />}
        />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};
